module.exports = __webpack_public_path__ + "static/img/jb5.be6cf80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/jb5.png
// module id = WGZG
// module chunks = 0